<template>
    <b-form-group class="d-inline" id="select-periodo-form" label="Período" label-for="select-mes">
      <b-row>
        <b-col lg="11">
          <b-form-select
              id="select-mes"
              v-model="selectedMonth"
              :options="months"
              value-field="value"
              text-field="text"
              type="text"
              class="selecterMonth"
              @change="updateValue()"
          />
          <b-form-select
              id="select-año"
              v-model="selectedYear"
              :options="años"
              value-field="value"
              text-field="value"
              type="text"
              class="selecterYear"
              @change="updateValue()"
          />
        </b-col>
        <b-col lg="1" class="icon">
          <i
              class="hand bx bx-x font-size-24"
              @click="clear"
          />
        </b-col>
      </b-row>
    </b-form-group>
</template>

<script>
import moment from 'moment';
export default {
    data(){
        return{
            months: [
                {value: "01", text: "Enero"},
                {value: "02", text: "Febrero"},
                {value: "03", text: "Marzo"},
                {value: "04", text: "Abril"},
                {value: "05", text: "Mayo"},
                {value: "06", text: "Junio"},
                {value: "07", text: "Julio"},
                {value: "08", text: "Agosto"},
                {value: "09", text: "Septiembre"},
                {value: "10", text: "Octubre"},
                {value: "11", text: "Noviembre"},
                {value: "12", text: "Diciembre"},
            ],
            selectedMonth: null,
            selectedYear: null
        };
    },
    props:["anioDesde", "anioHasta"],
    methods: {
        updateValue() {
            if (this.selectedMonth && this.selectedYear){
                let date = this.selectedYear.toString() + '-' + this.selectedMonth.toString().padStart(2,0) + '-' + '01';  
                let startDate = moment(date).startOf('month').format('YYYY-MM-DD');
                let endDate = moment(date).endOf('month').format('YYYY-MM-DD');
                this.$emit('change', {"fechaDesde": startDate, "fechaHasta": endDate})
            }
        },
        firstRequest() {
          this.selectedMonth = ''
          this.selectedYear = ''
          this.$emit('change', {"fechaDesde": new Date("2000-01-01"), "fechaHasta": new Date()})
        },
        clear () {
          this.firstRequest()
        }
    },
    mounted(){        
        this.selectedMonth = moment().format('MM');
        this.selectedYear = moment().format('YYYY');
        this.firstRequest();
    },
    computed: {
        años() {
            let result = [];
            for(let i = parseInt(this.anioDesde); i < parseInt(this.anioHasta) +1; i++){
                result.push(i.toString());
            }
            return result.reverse();
        }
    }
};
</script>

<style scoped>
.selecterMonth{
    width: 58%;
}
.selecterYear{
    width: 40%;
    margin-left: 2%;
}
.hand {
  cursor: pointer;
}
.icon {
  margin-left: -25px;
  margin-top: 5px;
}
</style>
